"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIdentifier = exports.ModuleMetadataSymbol = void 0;
exports.ModuleMetadataSymbol = Symbol.for('module metadata');
const createIdentifier = (sym) => sym;
exports.createIdentifier = createIdentifier;
//# sourceMappingURL=symbols.js.map